import React, { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { Header } from 'modulesCommon/Header/containers'

export const SBXLayout: FC = () => {
  return (
    <>
      <Header />
      <Outlet />
    </>
  )
}
